import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const searchApi = {
  get(params?: cyrian.api.search.Params): ApiResponse<WrappedResult<cyrian.api.search.ResponseItem[]>> {
    return request({
      method: 'get',
      url: '/search',
      params,
    });
  },
};

export default searchApi;
